import React from "react";
import { Link } from "react-router-dom";
import Container from "../Container/Index";
import Title from "../Title/Index";
import ImageTag from "../ImageTag/Index";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "./index.css";
import left from "../../images/circleLeft.png";
import right from "../../images/circleRight.png";

const NewsSlider = ({ Data }) => {
  return (
    <section className="newsHighlights" id="media-news">
      <Container containerClass="float-end position-relative">
        <div className="col-lg-6 col-12 m-auto text-center">
          <Title firstHeading={"latest updates"} />
        </div>

        <div className="position-relative flex-center justify-content-center">
          <button className="newsHighlights__nav newsHighlights__nav--prev">
            <img src={left} alt="left" />
          </button>

          <div className="col-lg-10 col-11 mx-auto float-start newsHighlights__outer">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              navigation={{
                nextEl: ".newsHighlights__nav--next",
                prevEl: ".newsHighlights__nav--prev",
              }}
              autoplay={{ delay: 8000, disableOnInteraction: false }}
              loop={Data.length > 2}
              spaceBetween={40}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
              }}
              className="newsHighlights__main-swiper"
            >
              {Data.map((slide, index) => {
                const slideKey = slide.id ?? `news-slide-${index}`;
                const paginationClass = `newsHighlights__pagination--${index}`;
                const hasLink =
                  typeof slide.link === "string" && slide.link.trim() !== "";

                const slideContent = (
                  <div className="newsHighlights__slide">
                    {/* LEFT SIDE IMAGE SWIPER */}
                    <div className="newsHighlights__visual">
                      <Swiper
                        modules={[Pagination, Autoplay, EffectFade]}
                        pagination={{
                          el: `.${paginationClass}`,
                          clickable: true,
                        }}
                        autoplay={{
                          delay: 5000,
                          disableOnInteraction: false,
                        }}
                        loop={(slide.images || []).length > 1}
                        effect="fade"
                        fadeEffect={{ crossFade: true }}
                        className="newsHighlights__child-swiper"
                      >
                        {(slide.images || []).map((image, imageIndex) => (
                          <SwiperSlide key={`${slideKey}-img-${imageIndex}`}>
                            <div className="newsHighlights__image">
                              <ImageTag
                                ImagePath={image.src}
                                ImageAlt={image.alt || slide.title}
                                ImageClass=""
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>

                    {/* RIGHT SIDE CONTENT */}
                    <div className="newsHighlights__content">
                      {slide.quote && (
                        <p className="newsHighlights__quote">{slide.quote}</p>
                      )}
                    </div>
                  </div>
                );

                return (
                  // FIX: key moved to SwiperSlide directly; wrapping div removed
                  <SwiperSlide key={slideKey} className="position-relative">
                    {hasLink ? (
                      <Link
                        to={slide.link}
                        className="newsHighlights__link-wrapper"
                      >
                        {slideContent}
                      </Link>
                    ) : (
                      slideContent
                    )}
                    <div
                      className={`newsHighlights__pagination ${paginationClass}`}
                    ></div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>

          <button className="newsHighlights__nav newsHighlights__nav--next">
            <img src={right} alt="right" />
          </button>
        </div>
      </Container>
    </section>
  );
};

export default NewsSlider;
